import './index.scss';
import util from 'promokit-util';
import screenfull from 'screenfull';

class VideoPlayer {
  constructor(config) {
    this.$name = 'promokit-videoplayer';
    this.$store = {
      url: config.url,
      controls: config.controls,
      autoplay: config.autoplay,
      poster: config.poster,
      loop: config.loop,
      oldIE: /msie 10|msie 9/i.test(navigator.userAgent.toLocaleLowerCase()),
      isMobile: util.location.isMobile,
      isIphone: /(iphone)/i.test(navigator.userAgent.toLowerCase()),
      isPlay: false,
      controlImportant: false,
      timer: false,
      waiting: false
    };
    this.$dom = {};
    this.$el = $(config.el);
    this.$video = null;
    this.$animationFrame = new util.animationFrame(() => {
      this.updateProgress();
      this.updateTime();
    });
    this.$el.addClass(this.$name);
    this.$store.oldIE && this.$el.addClass(`${this.$name}--ie`);
    this.loadPlayer();
  }

  loadPlayer() {
    let template = `<video class="${this.$name}__screen">
                    <source src="${this.$store.url}" type="video/mp4">
                  </video>`;

    this.$video = this.$el.append(template).find('video');
    this.setVideoEvent();
    this.$video[0].load();

    this.setFullScreenChangeEvent();
    this.setContextEvent();
  }

  loadPoster() {
    if (!this.$store.poster) return '';
    return util.trim(this.$store.poster, true) ? `<div class="${this.$name}__poster" style="background:url('${this.$store.poster}') #000 50% 50% no-repeat"></div>` : '';
  }

  loadCover() {
    const template = `${this.loadPoster()}
        <div class="${this.$name}__cover"></div>`;

    const controls = this.$el.append(template);

    this.$dom.cover = controls.find(`.${this.$name}__cover`);
    this.$dom.poster = controls.find(`.${this.$name}__poster`);
  }

  loadControls() {
    const template = `<div class="${this.$name}__controls">
            <div class="${this.$name}__controls-spinner"></div>
            <div class="${this.$name}__controls-progress">
              <div class="${this.$name}__controls-progress-time"></div>
              <div class="${this.$name}__controls-progress-bar"></div>
            </div>
            
            <button class="${this.$name}__controls-button ${this.$name}__controls-button--play">재생</button>
            <button class="${this.$name}__controls-button ${this.$name}__controls-button--pause">정지</button>
            
            
           <div class="${this.$name}__time"></div>
            
            <button class="${this.$name}__mute-button ${this.$name}__mute-button--off">
              <svg version="1.1" viewBox="0 0 36 36">
                <path d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"></path>
                <path d="M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z"></path>
              </svg>
            </button>
            
            <button class="${this.$name}__mute-button ${this.$name}__mute-button--on">
              <svg version="1.1" viewBox="0 0 36 36" >
                <path d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"></path>
              </svg>
            </button>
            
            <button class="${this.$name}__fullscreen-button ${this.$name}__fullscreen-button--off">
              <svg version="1.1" viewBox="0 0 36 36">
                <g><path d="m 14,14 -4,0 0,2 6,0 0,-6 -2,0 0,4 0,0 z"></path></g>
                <g><path d="m 22,14 0,-4 -2,0 0,6 6,0 0,-2 -4,0 0,0 z"></path></g>
                <g><path d="m 20,26 2,0 0,-4 4,0 0,-2 -6,0 0,6 0,0 z"></path></g>
                <g><path d="m 10,22 4,0 0,4 2,0 0,-6 -6,0 0,2 0,0 z"></path></g>
              </svg>
            </button>
            
            <button class="${this.$name}__fullscreen-button ${this.$name}__fullscreen-button--on">
              <svg  version="1.1" viewBox="0 0 36 36" >
                <g><path d="m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z"></path></g>
                <g><path d="m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z"></path></g>
                <g><path d="m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z"></path></g>
                <g><path d="M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z"></path></g>
              </svg>
            </button>
        </div>
        <div class="${this.$name}__controls-cover"></div>`;

    const controls = this.$el.append(template);

    this.$dom.controls = controls.find(`.${this.$name}__controls`);
    this.$dom.cover = controls.find(`.${this.$name}__cover`);
    this.$dom.spinner = controls.find(`.${this.$name}__controls-spinner`);
    this.$dom.poster = controls.find(`.${this.$name}__poster`);
    this.$dom.progress = controls.find(`.${this.$name}__controls-progress`);
    this.$dom.progressBar = controls.find(`.${this.$name}__controls-progress-bar`);
    this.$dom.progressTime = controls.find(`.${this.$name}__controls-progress-time`);
    this.$dom.play = controls.find(`.${this.$name}__controls-button--play`);
    this.$dom.pause = controls.find(`.${this.$name}__controls-button--pause`);
    this.$dom.fullscreenOn = controls.find(`.${this.$name}__fullscreen-button--on`);
    this.$dom.fullscreenOff = controls.find(`.${this.$name}__fullscreen-button--off`);
    this.$dom.muteOn = controls.find(`.${this.$name}__mute-button--on`);
    this.$dom.muteOff = controls.find(`.${this.$name}__mute-button--off`);
    this.$dom.time = controls.find(`.${this.$name}__time`);

    this.setControlsEvent();
  }

  updateProgress() {
    if (!this.$store.controls) return;
    let bar = (this.currentTime / this.duration);
    this.$dom.progressBar.css({'transform': `scaleX(${bar > 1 ? 1 : bar})`});
    if (!this.$store.enabledTime) {
      this.$dom.progress.addClass(`${this.$name}__controls-progress--no-hour`);
    }
  }

  updateTime() {
    if (!this.$store.controls) return;

    if (!this.$store.enabledTime) {
      this.$dom.progress.addClass(`${this.$name}__controls-progress--no-hour`);
    }

    this.$dom.time.text(this.getTimeString(this.duration - this.currentTime));
  }

  updateScreenSize() {
    let setWidth = 0;
    let setHeight = 0;
    let contextWidth = this.$el[0].offsetWidth;
    let contextHeight = this.$el[0].offsetHeight;
    let videoWidth = this.$video[0].videoWidth;
    let videoHeight = this.$video[0].videoHeight;

    if ((contextWidth / contextHeight) < (videoWidth / videoHeight)) {
      setWidth = contextHeight * videoWidth / videoHeight;
      setHeight = contextHeight;
    }
    else {
      setWidth = contextWidth;
      setHeight = contextWidth * videoHeight / videoWidth;
    }

    this.$video.css({
      width: `${setWidth}px`,
      height: `${setHeight}px`
    });
  }

  visibleControls(q) {
    if (q) {
      this.$el.addClass(`${this.$name}--show-controls`);
    }
    else {
      if (this.$store.controlImportant) return;
      this.$el.removeClass(`${this.$name}--show-controls`);
    }
  }

  hideTimer() {
    clearTimeout(this.$store.hideTimer);

    this.$store.hideTimer = setTimeout(() => {
      this.$store.controlImportant = false;
      this.visibleControls(false);
    }, 2000);
  }

  setVideoEvent() {
    this.$video.on('canplaythrough', this.handleCanplay.bind(this));
    this.$video.on('ended', () => this.$el.trigger('ended'));
    this.$video.on('waiting', () => this.$el.trigger('waiting'));
    this.$video.on('playing', () => this.$el.trigger('playing'));
    this.$video.on('timeupdate', () => this.$el.trigger('timeupdate'));
  }

  setContextEvent() {
    this.$el.on('play', () => {
      this.$store.isPlay = true;
      this.$animationFrame.stop();
      this.$animationFrame.start();
      this.$el.addClass(`${this.$name}--play`);
      this.$el.removeClass(`${this.$name}--waiting ${this.$name}--ended`);
      this.$dom.poster.addClass(`${this.$name}__poster--hide`);
      this.visibleControls(false);
    });

    this.$el.on('pause', () => {
      this.$store.isPlay = false;
      this.updateProgress();
      this.$el.removeClass(`${this.$name}--play ${this.$name}--waiting`);
      this.visibleControls(true);
      this.$animationFrame.stop();
    });

    this.$el.on('ended', () => {
      this.$store.isPlay = false;
      this.$el.addClass(`${this.$name}--ended`);
      this.$el.removeClass(`${this.$name}--play ${this.$name}--waiting`);
      this.$dom.poster.removeClass(`${this.$name}__poster--hide`);
      this.$animationFrame.stop();
      this.updateProgress();

      if (this.$store.loop) {
        this.seek(0);
        this.play();
      }
      else {
        this.visibleControls(true);
      }
    });

    this.$el.on('waiting ', () => {
      this.$store.waiting = true;
      this.$el.addClass(`${this.$name}--waiting`);
    });

    this.$el.on('playing timeupdate', (e) => {
      if (this.$store.waiting) {
        this.$el.removeClass(`${this.$name}--waiting`);
        this.$store.waiting = false;
      }
    });

    this.$el.on('playing', () => {
      this.$animationFrame.stop();
      this.$animationFrame.start();
    });

    this.$el.on('fullscreenstart ', () => {
      this.$el.addClass(`${this.$name}--fullscreen`);
    });

    this.$el.on('fullscreenend', () => {
      this.$el.removeClass(`${this.$name}--fullscreen`);
    });

    this.$el.on('mute', () => {
      this.$el.addClass(`${this.$name}--mute`);
    });

    this.$el.on('unMute', () => {
      this.$el.removeClass(`${this.$name}--mute`);
    });

    this.$el.on('stop', () => {
      this.$store.isPlay = false;
      this.$animationFrame.stop();
      this.$el.addClass(`${this.$name}--ended`);
      this.$el.removeClass(`${this.$name}--play ${this.$name}--waiting`);
      this.$dom.poster.removeClass(`${this.$name}__poster--hide`);
      this.visibleControls(true);
      this.$dom.progressBar.css({'transform': `scaleX(0)`});
    });
  }

  setControlsEvent() {
    this.$dom.play.on('click', this.play.bind(this));
    this.$dom.pause.on('click', this.pause.bind(this));
    this.$dom.muteOn.on('click', this.mute.bind(this));
    this.$dom.muteOff.on('click', this.unMute.bind(this));
    this.$dom.fullscreenOn.on('click', this.handleFullScreenStart.bind(this));
    this.$dom.fullscreenOff.on('click', this.handleFullScreenEnd.bind(this));
    this.$dom.progress.on('click', (e) => {
      this.$animationFrame.stop();
      this.$dom.poster.addClass(`${this.$name}__poster--hide`);
      let progressWidth = this.$dom.progress.width();
      this.$dom.progressBar.css({'transform': `scaleX(${e.offsetX / progressWidth})`});
      this.seek((1 - (progressWidth - e.offsetX) / progressWidth) * this.duration);
      this.updateTime();
    });

    if (this.$store.isMobile) {
      this.$dom.cover.on('click', () => {
        this.visibleControls(true);
        this.hideTimer();
      });
    }

    if (!this.$store.isMobile) {
      this.$el.on('mousemove', () => {
        if (!this.$store.isPlay) return;
        clearTimeout(this.$store.timer);
        this.visibleControls(true);
        this.$store.timer = setTimeout(() => {
          if (!this.$store.isPlay) return;
          if (this.$store.controlImportant) return;
          this.visibleControls(false);
        }, 1000);
      });
      this.$dom.progress.on('mousemove', (e) => {
        this.$dom.progressTime.show();
        this.$dom.progressTime.css('left', e.offsetX);
        let progressWidth = this.$dom.progress.width();
        this.$dom.progressTime.text(this.getTimeString(parseInt((1 - (progressWidth - e.offsetX) / progressWidth) * this.duration)));
      });
      this.$dom.progress.on('mouseover', () => {
        this.visibleControls(true);
        this.$store.controlImportant = true;
      });
      this.$dom.progress.on('mouseout', () => {
        this.visibleControls(false);
        this.$store.controlImportant = false;
        this.$dom.progressTime.hide();
      });
    }
  }

  setFullScreenChangeEvent() {
    if (this.$store.oldIE) {
      $(window).on('keydown.fullscreen', e => {
        if (e.keyCode == '27') {
          this.handleFullScreenEnd();
        }
      });
      return;
    }

    screenfull.on('change', () => {
      if (screenfull.isFullscreen) {
        this.$el.trigger('fullscreenstart');
      }
      else {
        this.$el.trigger('fullscreenend');
      }
    });
  }

  getTimeString(t) {
    let hour = Math.floor(t / 60 / 60);
    let min = Math.floor(t / 60 % 60);
    let sec = Math.floor(t % 60);

    if (sec < 0) {
      sec = '0';
    }

    if (min < 0) {
      min = '0';
    }

    if (sec < 10) {
      sec = `0${sec}`;
    }

    if (hour > 0) {
      hour = `${hour}:`;
      min = `${min > 10 ? '' : '0'}${min}:`;
    }
    else {
      hour = '';
      min = `${min}:`;
    }

    return `${hour}${min}${sec}`;
  }

  handleCanplay() {
    this.$video.off('canplaythrough');
    this.$store.enabledTime = Math.floor(this.duration / 60 / 60) > 0;
    this.loadCover();
    this.$store.controls && this.loadControls();
    this.$el.addClass(`${this.$name}--ready`);
    this.$el.trigger('canplay');
    this.updateTime();
    this.updateScreenSize();
    this.$store.autoplay && this.autoplay();
  }

  handleFullScreenStart() {
    if (this.$store.isIphone) {
      this.play();
    }
    if (!this.$store.isIphone && !this.$store.oldIE) {
      screenfull.request(this.$el[0]);
    }

    this.$el.addClass(`${this.$name}--fullscreen`);
  }

  handleFullScreenEnd() {
    if (!this.$store.isIphone && !this.$store.oldIE) {
      screenfull.exit();
    }

    this.$el.removeClass(`${this.$name}--fullscreen`);
  }

  on(e, eventListener) {
    this.$el.on(e, eventListener);
  }

  off(e) {
    this.$el.off(e);
  }

  autoplay() {
    this.mute();
    this.play();
  }

  play() {
    this.$video[0].play();
    this.$el.trigger('play');
  }

  stop() {
    this.$video[0].pause();
    this.$video[0].currentTime = 0;
    this.$el.trigger('stop');
  }

  pause() {
    this.$video[0].pause();
    this.$el.trigger('pause');
  }

  mute() {
    this.$video[0].muted = true;
    this.$el.trigger('mute');
  }

  unMute() {
    this.$video[0].muted = false;
    this.$el.trigger('unMute');
  }

  seek(t) {
    this.$video[0].currentTime = t;
  }

  get duration() {
    return this.$video[0].duration;
  }

  get currentTime() {
    return this.$video[0].currentTime;
  }
}

export default VideoPlayer;
